module.exports = __webpack_public_path__ + "img/login-main-group.f41cd34e.svg";